<template>
  <div>
    <v-dialog
      scrollable
      persistent
      :value="drugInternal !== null"
      max-width="600"
    >
      <material-card
:title="$t('globals.drugs')"
        :color="$vuetify.theme.themes.light.primary"
        icon="edit"
        v-if="drugInternal !== undefined && drugInternal !== null"
      >
        <v-card-text>
          <v-form :disabled="loading" ref="form" v-model="valid">
            <v-container>
              <div class="row">
                <div class="col-12 col-md-6">
                  <pbas-date-picker
                    class="required"
                    :value="drugInternal.EffectiveDate"
                    @update-date="drugInternal.EffectiveDate = $event"
                    :label="$t('components.inmemorydependants.effective_date')"
                    :rules="[$rules.required]"
                  ></pbas-date-picker>
                </div>
                <div class="col-12 col-md-6">
                  <no-autocomplete-textfield
                    v-model="drugInternal.Din"
                    :rules="[
                      $rules.required,
                      $rules.numericString,
                      $rules.dynamic.length(8),
                    ]"
                    class="required"
                    :label="$t('headers.expense_info.din')"
                  />
                </div>
                <div class="col-12 col-md-6">
                  <no-autocomplete-textfield
                  :label="$t('globals.name')"
                    v-model="drugInternal.Name"
                    :rules="[$rules.required]"
                    class="required"
                  />
                </div>
                <!-- <div class="col-12 col-md-6">
                  <pbas-date-picker
                    class="required"
                    :value="drugInternal.DeactivatedAt"
                    label="Deactivated At"
                    :rules="[$rules.required]"
                    disabled
                  ></pbas-date-picker>
                </div> -->
                <!-- <div class="col-12 col-md-6">
                  <v-checkbox label="Active" v-model="drugInternal.IsActive" />
                </div> -->
              </div>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            :loading="loading"
            @click="
              drugInternal = null;
              $emit('cancel');
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            :loading="loading"
            @click="save()"
            :disabled="!drugInternal.Din || !drugInternal.Name"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
        <error-handler :error="error"></error-handler>
      </material-card>
    </v-dialog>
  </div>
</template>

<script>
import deepClone from "../../utils/deepClone";
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../../components/ErrorHandler";
import NoAutocompleteTextfield from "../../components/NoAutocompleteTextfield";

export default {
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
  },
  props: {
    drug: Object,
  },
  data: () => ({
    valid: false,
    drugInternal: null,
    loading: false,
    error: null,
  }),
  watch: {
    drug: {
      handler(val) {
        this.drugInternal = deepClone(this.drug);
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions("claims", ["saveDrug"]),
    async save() {
      try {
        await this.withLoad(this.saveDrug(this.drugInternal));
        this.$emit("update:drug", this.drugInternal);
      } catch (e) {
        this.error = e;
      }
    },
    async withLoad(promise) {
      this.error = null;
      this.loading = true;
      try {
        await promise;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
